import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './RadioItem.module.css';
import { RadioWidget } from '../RadioWidget';
import { RadioLabel } from '../RadioLabel';

const bindClasses = classNameBind.bind(styles);

const RadioItem = ({
  id,
  name,
  value,
  selected,
  disabled,
  onClick,
  onBlur,
  dataId,
  label,
  labelTitle,
  caption,
}) => (
  <div
    className={bindClasses('wrapper', { disabled })}
    key={id}
    data-ppuc-id={`${dataId}.item`}
  >
    <div className={bindClasses('main')}>
      <div className={bindClasses('widget')}>
        <RadioWidget
          name={name}
          id={id}
          value={value}
          selected={selected}
          disabled={disabled}
          onClick={onClick}
          onBlur={onBlur}
          dataId={dataId}
        />
      </div>
      <RadioLabel
        id={id}
        disabled={disabled}
        dataId={dataId}
        label={label}
        labelTitle={labelTitle}
        caption={caption}
      />
    </div>
  </div>
);

RadioItem.defaultProps = {
  labelTitle: null,
  caption: null,
  childrenElement: null,
  disabled: false,
};

export { RadioItem };
